import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'app',
        component: HomeComponent,
      },
      {
        path: 'link',
        loadChildren: () =>
          import('@et/elsi/signing-room').then(
            (mod) => mod.ElsiSigningRoomModule,
          ),
      },
      { path: '', redirectTo: 'app', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
